import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Column, Row } from 'app/design/primitives/box';
import { PCImage } from 'app/design/primitives/image';
import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';

const theme = createDSTheme();

const imageRoundedStyle = { borderRadius: 12 } as const;

interface SubjectCardProps {
  image?: string | null;
  name: string;
  subtitle: string;
  recommended?: boolean;
}

export function SubjectCard({ image, name, recommended, subtitle }: SubjectCardProps) {
  const { t } = useTranslation('ratings');
  const recommendationColor = recommended ? 'text.positive' : 'text.error';
  const recommendationEmoji = recommended ? '👍' : '👎';
  const recommendationLabel = recommended ? t('newRating.figmaRecommended') : t('newRating.figmaNotRecommended');

  return (
    <View
      style={{
        alignItems: 'center',
        backgroundColor: theme.colors['surface.primary-neutral'],
        borderRadius: theme.borderRadii['radius.lg'],
        flexDirection: 'row',
        gap: theme.spacing['spacing.general.x2'],
        padding: theme.spacing['spacing.general.x2'],
      }}
    >
      {image ? (
        <PCImage aspectRatio={1} height={44} source={{ uri: image }} style={imageRoundedStyle} width={44} />
      ) : (
        <View
          style={{
            alignItems: 'center',
            backgroundColor: theme.colors['surface.tertiary-neutral'],
            borderRadius: theme.borderRadii['radius.md'],
            height: 44,
            justifyContent: 'center',
            width: 44,
          }}
        >
          <MaterialCommunityIcons color={theme.colors['text.secondary']} name="account-outline" size={22} />
        </View>
      )}

      <Column flex={1} minWidth={0}>
        <Text color="text.secondary" fontSize={12} numberOfLines={1}>
          {subtitle}
        </Text>
        <Text color="text.primary" fontSize={16} fontWeight="600" numberOfLines={1}>
          {name}
        </Text>
      </Column>

      {recommended !== undefined ? (
        <Row alignItems="center" gap="spacing.general.x1">
          <Text fontSize={14}>{recommendationEmoji}</Text>
          <Text color={recommendationColor} fontSize={14} fontWeight="700">
            {recommendationLabel}
          </Text>
        </Row>
      ) : null}
    </View>
  );
}
